<app-main-nav></app-main-nav>

<div class="content">
  <router-outlet/>
</div>

<p-toast [showTransformOptions]="'translateX(100%)'"></p-toast>
<p-confirmDialog></p-confirmDialog>
